// // src/data/categoryData.js

// const categoryData = {
//   temples: {
//     title: "Temple Work",
//     description: "Luxury Makrana marble temples handcrafted with heritage designs.",
//     staticImages: [
//       "/images/temples/temple1.jpg",
//       "/images/temples/temple2.jpg",
//       "/images/temples/temple3.png",
//       "/images/temples/temple4.jpg",
//       "/images/temples/temple5.jpg",
//       "/images/temples/temple6.jpg",
//       "/images/temples/temple7.jpg",
//       "/images/temples/temple8.jpg",
//       "/images/temples/temple9.jpg",
//       "/images/temples/temple10.jpeg",
//     ],
//     // blobContainer: "https://yourstorageaccount.blob.core.windows.net/temples/"
//   },
//   mosques: {
//     title: "Mosque Work",
//     description: "Spiritual marble works for mosques crafted in pure Makrana marble.",
//     staticImages: [
//       "/images/mosques/mosque1.jpg",
//       "/images/mosques/mosque2.jpg",
//       "/images/mosques/mosque3.jpg",
//       "/images/mosques/mosque4.jpg",
//       "/images/mosques/mosque5.jpg",
//       "/images/mosques/mosque6.jpg",
//       "/images/mosques/mosque7.jpg",
//       "/images/mosques/mosque8.jpg",
//       "/images/mosques/mosque9.jpg",
//       "/images/mosques/mosque10.jpg",
//     ],
//     // blobContainer: "https://yourstorageaccount.blob.core.windows.net/mosques/"
//   },
//   handicrafts: {
//     title: "Handicrafts",
//     description: "Elegant Makrana marble handicrafts with timeless beauty.",
//     staticImages: [
//       "/images/handicrafts/handicraft1.jpg",
//       "/images/handicrafts/handicraft2.jpg",
//       "/images/handicrafts/handicraft3.jpg",
//       "/images/handicrafts/handicraft4.png",
//       "/images/handicrafts/handicraft5.jpg",
//       "/images/handicrafts/handicraft6.jpg",
//       "/images/handicrafts/handicraft7.jpg",
//       "/images/handicrafts/handicraft8.jpg",
//       "/images/handicrafts/handicraft9.jpg",
//       "/images/handicrafts/handicraft10.jpg",
//     ],
//     // blobContainer: "https://yourstorageaccount.blob.core.windows.net/handicrafts/"
//   },
//   raw: {
//     title: "Raw Marble",
//     description: "Makrana raw marble blocks & slabs for custom projects.",
//     staticImages: [
//       "/images/raw/raw1.jpg",
//       "/images/raw/raw2.jpg",
//       "/images/raw/raw3.jpg",
//       "/images/raw/raw4.jpg",
//       "/images/raw/raw5.jpg",
//       "/images/raw/raw6.jpg",
//       "/images/raw/raw7.jpg",
//       "/images/raw/raw8.jpg",
//       "/images/raw/raw9.jpg",
//       "/images/raw/raw10.jpg",
//     ],
//     // blobContainer: "https://yourstorageaccount.blob.core.windows.net/raw/"
//   },
 
//   inlay: {
//     title: "Inlay Work",
//     description: "Intricate inlay marble work for luxury designs.",
//     staticImages: [
//       "/images/Inlay/Inlay1.jpg",
//       "/images/Inlay/Inlay2.jpg",
//       "/images/Inlay/Inlay3.jpg",
//       "/images/Inlay/Inlay4.jpg",
//       "/images/Inlay/Inlay5.jpg",
//       "/images/Inlay/Inlay6.jpg",
//       "/images/Inlay/Inlay7.jpg",
//       "/images/Inlay/Inlay8.jpg",
//       "/images/Inlay/Inlay9.jpg",
//       "/images/Inlay/Inlay10.jpg",
//       // add as many as you want
//     ],
//   },

//   "marble-types": {
//     title: "All Marble Types",
//     description: "Makrana marble varieties: Albeta, Dungri, Chosira, and more.",
//     staticImages: [
//       "/images/marble-types/albeta.jpg",
//       "/images/marble-types/dungri.jpg",
//       "/images/marble-types/chosira.jpg",
//       "/images/marble-types/figure02.jpg",
//       "/images/marble-types/figure01.jpg",
//       "/images/marble-types/marble6.jpg",
//       "/images/marble-types/marble7.jpg",
//       "/images/marble-types/marble8.jpg",
//       "/images/marble-types/marble9.jpg",
//       "/images/marble-types/marble10.jpg",
//     ],
//     // blobContainer: "https://yourstorageaccount.blob.core.windows.net/marble-types/"
//   }
// };





//second
// export default categoryData;
// import categoryData from "../data/categoryData"; // 👈 import this at the top

// // Inside your Home component
// <section className="py-16 bg-gray-800">
//   <h2 className="text-3xl font-bold text-center mb-12">Luxury Showcase</h2>

//   <div className="max-w-7xl mx-auto px-6">
//     <Swiper
//       slidesPerView={1}
//       spaceBetween={20}
//       breakpoints={{
//         768: { slidesPerView: 2 },
//         1024: { slidesPerView: 3 },
//       }}
//       autoplay={{ delay: 2500, disableOnInteraction: false }}
//       loop={true}
//       pagination={{ clickable: true }}
//       navigation={true}
//       modules={[Autoplay, Pagination, Navigation]}
//       className="mySwiper"
//     >
//       {Object.entries(categoryData).map(([slug, data], i) => (
//         <SwiperSlide key={i}>
//           <a
//             href={`/category/${slug}`}
//             className="relative h-72 rounded-xl overflow-hidden shadow-lg group block"
//           >
//             <img
//               src={data.staticImages?.[0] || "/images/marble-bg.jpg"} // first image as cover
//               alt={data.title}
//               className="w-full h-full object-cover transform group-hover:scale-110 transition duration-500"
//             />
//             <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
//               <h3 className="text-2xl font-bold text-white drop-shadow">{data.title}</h3>
//             </div>
//           </a>
//         </SwiperSlide>
//       ))}
//     </Swiper>
//   </div>
// </section>


const categoryData = {
  temples: {
    title: "Temple Work",
    description: "Luxury Makrana marble temples handcrafted with heritage designs.",
    staticImages: [
      "/images/temples/temple1.jpg",
      "/images/temples/temple2.jpg",
      "/images/temples/temple3.png",
      "/images/temples/temple4.jpg",
      "/images/temples/temple5.jpg",
      "/images/temples/temple6.jpg",
      "/images/temples/temple7.jpg",
      "/images/temples/temple8.jpg",
      "/images/temples/temple9.jpg",
      "/images/temples/temple10.jpeg",
    ],
  },
  mosques: {
    title: "Mosque Work",
    description: "Spiritual marble works for mosques crafted in pure Makrana marble.",
    staticImages: [
      "/images/mosques/mosque1.jpg",
      "/images/mosques/mosque2.jpg",
      "/images/mosques/mosque3.jpg",
      "/images/mosques/mosque4.jpg",
    ],
  },
  handicrafts: {
    title: "Handicrafts",
    description: "Elegant Makrana marble handicrafts with timeless beauty.",
    staticImages: [
      "/images/handicrafts/handicraft1.jpg",
      "/images/handicrafts/handicraft2.jpg",
      "/images/handicrafts/handicraft3.jpg",
      "/images/handicrafts/handicraft4.png",
      "/images/handicrafts/handicraft5.jpg",
      "/images/handicrafts/handicraft6.jpg",
      "/images/handicrafts/handicraft7.jpg",
      "/images/handicrafts/handicraft8.jpg",
      "/images/handicrafts/handicraft9.jpg",
      "/images/handicrafts/handicraft10.jpg",
    ],
  },
  raw: {
    title: "Raw Marble",
    description: "Makrana raw marble blocks & slabs for custom projects.",
    staticImages: [
      "/images/raw/raw1.jpg",
      "/images/raw/raw2.jpg",
      "/images/raw/raw3.jpg",
      "/images/raw/raw4.jpg",
      "/images/raw/raw5.jpg",
      "/images/raw/raw6.jpg",
      "/images/raw/raw7.jpg",
      "/images/raw/raw8.jpg",
      "/images/raw/raw9.jpg",
      "/images/raw/raw10.jpg",
    ],
  },
  inlay: {
    title: "Inlay Work",
    description: "Intricate inlay marble work for luxury designs.",
    staticImages: [
      "/images/inlay/Inlay1.jpg",
      "/images/inlay/Inlay2.jpg",
      "/images/inlay/Inlay3.jpg",
      "/images/inlay/Inlay4.jpg",
      "/images/inlay/Inlay5.jpg",
      "/images/inlay/Inlay6.jpg",
      "/images/inlay/Inlay7.jpg",
      "/images/inlay/Inlay8.jpg",
      "/images/inlay/Inlay9.jpg",
      "/images/inlay/Inlay10.jpg",
    ],
  },

  site: {
  title: "Site Work",
  description: "Makrana marble installations for flooring, walls, and architecture projects.",
  staticImages: [
    "/images/site/site1.jpg",
    "/images/site/site2.jpg",
    "/images/site/site3.jpg",
  ],
  // Optional blobContainer if you plan to fetch images dynamically later
  // blobContainer: "https://yourstorageaccount.blob.core.windows.net/site/"
},

hometemple: {
    title: "Home Temples",
    description: "Exquisite Makrana marble home temples for personal worship.",
    staticImages: [
      "/images/hometemple/hometemple1.jpg",
    ],
    showInShowcase: true 
  },

  fountain: {
    title: "Fountain Work",
    description: "Elegant Makrana marble fountains for gardens and courtyards.",
    staticImages: [
      "/images/fountain/fountain1.jpg",
    ],
  },

  homes: {
    title: "Elegant Home Interiors",
    description: "Luxurious Makrana marble interiors for upscale homes.",
    staticImages: [
      "/images/home/home1.jpg",
      "/images/home/home2.jpg",
    ],
  },


  marbletypes: {
    title: "All Marble Types",
    description: "Makrana marble varieties: Albeta, Dungri, Chosira, and more.",
    staticImages: [
      "/images/marble-types/albeta.jpg",
      "/images/marble-types/figure02.jpg",
      "/images/marble-types/figure01.jpg",
    ],
  },
  "tulsi-pots": {
    title: "Tulsi Pots",
    description: "Handcrafted Makrana marble Tulsi pots for homes, temples, and courtyards.",
    staticImages: [
      "/images/tulsi-pod.jpg"
    ],
  },
};

export default categoryData;

